let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fzHDF")).then(() => parcelRequire('4WZ5N'));